import { useTranslation } from '@shared/core/i18n';

export const useLayoutEngineTranslations = () => {
  const { tq } = useTranslation('layoutEngine');

  return {
    help: tq`Guest Help`,
    about: tq`About`,
    browseDesigns: tq`Browse Designs`,
  };
};
